import app from 'app';

/** Getters -
 * Asset Editor Data Retrievers
 * Used via $store.getters.*
 */
export default {
  AGD: (state) => {
    return state.workModel.agd;
  },

  workModel: (state) => {
    return state.workModel;
  },

  assetModel: (state) => {
    return state.assetModel;
  },

  applyVolumeToAll: (state) => {
    return state.applyVolumeToAll;
  },

  pageTmpState: (state) => {
    return state.pageTmpState;
  },

  timeInAsset: (state) => {
    return state.timeInAsset;
  },

  confirmedVolumeApplyAll: (state) => {
    return state.confirmedVolumeApplyAll;
  },

  story: (state) => {
    return state.story;
  },

  rtpModel: (state) => {
    return state.rtpModel;
  },

  pages: (state) => {
    return state.pages;
  },

  groups: (state) => {
    return state.groups;
  },

  tmpAGD: (state) => {
    return state.tmpAGD;
  },

  presets: (state) => {
    return state.themeInfo.presets;
  },

  transitionPresets: (state) => {
    return state.themeInfo.transitionPresets;
  },

  stageDimensions: (state) => {
    return state.stageDimensions;
  },

  defaultEditorUrl: (state) => {
    return state.defaultEditorUrl;
  },

  analyticsData: (state) => {
    return state.analyticsData;
  },

  cssStyleObj(state) {
    return app.computeBgFromColorData(
      state.workModel.wallpaperMetaData.wallpaperData
    );
  },

  isInMyGallery(state) {
    return state.workModel.metadata.providerId === 'asset_server';
  },

  canDelete(state, getters) {
    const wm = state.workModel;
    return (
      !!wm.metadata.uploadStatus &&
      getters.isInMyGallery &&
      !app.assetType.isFRAGMENT(wm) &&
      !app.assetScore.isSELECTED(wm) &&
      (wm.metadata.uploadStatus === app.uploadStatus.FAILED ||
        wm.metadata.uploadStatus === app.uploadStatus.DONE)
    );
  },

  activePages(state) {
    return _.filter(state.pages, function (page) {
      if (_.isArray(page.agdAttributes) && page.agdAttributes.length) {
        const agd = _.clone(state.workModel.agd) || {};
        const activeAGDs = [];

        _.each(page.agdAttributes, (agdAttr) => {
          const agdPath = agdAttr.split('.');
          let accVal = null;

          _.each(agdPath, (key, i) => {
            accVal = accVal || agd[key];
            const next = agdPath[i + 1];

            if (next && _.isDefined(accVal)) {
              const child = _.isArray(accVal)
                ? _.find(accVal, (p) => p.id === next)
                : accVal[next];

              accVal = !_.isEmpty(child) ? child : null;
            }
          });

          if (!_.isEmpty(accVal)) {
            activeAGDs.push(agdPath[agdPath.length - 1]);
          }
        });

        return !_.isEmpty(activeAGDs);
      }
      // no agd! can't be active
      return false;
    });
  },

  blackListPages: (state) => (key) => {
    const agd = _.clone(state.workModel.agd) || {};
    return _.filter(agd[key], (val) => {
      return val.disabled;
    });
  },

  mergePageAndGroup: (state, getters) => (page) => {
    if (_.isArray(page.groupBy) && page.groupBy[0]) {
      const pageGroup = state.groups.find((g) => g.id === page.groupBy[0]);

      if (pageGroup) {
        return Object.assign(_.clone(pageGroup), page, {
          isBlackListed: getters.isBlackListed(page.id),
        });
      }
    }

    return page;
  },

  isBlackListed: (state) => (id) => {
    const preset = state.themeInfo.presets.find((preset) => preset.id === id);
    return !!(
      preset &&
      preset.assetBlacklist &&
      preset.assetBlacklist.includes(state.assetModel.get('type'))
    );
  },

  themeInfo: (state) => {
    return state.themeInfo;
  },

  /**
   * Check that workmodel has changed
   * @return {Boolean}
   */
  isDirty: (state) => {
    const pickProps = [
      'agd',
      'overlayTracks',
      'displayDuration',
      'displayEndTime',
      'previewResultData',
      'realTimePreviewResultData',
      'volumeControl',
      'onVoPlayVolumeControl',
      'assetItemSchemaDataModel',
    ];
    const o1 = _.cloneDeepAndClean(state.assetModel.pick(pickProps));
    const o2 = _.cloneDeepAndClean(_.pick(state.workModel, pickProps));
    return !_.isEqual(o1, o2) || !!state.applyVolumeToAll;
  },

  serializedTextOverlays(state) {
    const rv = _.cloneDeepAndClean(state.tmpAGD.textOverlays);
    _.each(rv, (to) => {
      _.each(to, (value, key) => {
        if (/^[_|$]/.test(key)) {
          delete to[key];
        }
      });
    });
    return rv;
  },

  isTempAgdDirty: (state) => {
    const cleanUnderscores = (obj) => {
      const keys = Object.keys(obj).filter((k) => {
        return k.startsWith('_');
      });
      for (const k of keys) {
        delete obj[k];
      }
    };
    const o1 = _.cloneDeepAndClean(state.tmpAGD);
    const o2 = _.cloneDeepAndClean(state.workModel.agd);
    cleanUnderscores(o1);
    cleanUnderscores(o2);
    return !_.isEqual(o1, o2);
  },

  isDurationChanged(state) {
    return state.newDuration && state.oldDuration !== state.newDuration;
  },

  isStoryboarding(state) {
    return state.isStoryboard && state.isStoryboarder;
  },

  isMouseDisabled(state) {
    return state.mouseDisabled;
  },

  /**
   * Returns state currentPage
   * @return {Object}
   */
  currentPage: (state) => {
    return _.find(state.pages, (p) => p && p.id === state.currentPageId);
  },

  disableAspectRatioCurtains: (state, getters) => {
    return !!getters.currentPage?.disableAspectRatioCurtains;
  },

  showTranscriptForEffectPage(state, getters, rootState) {
    if (state.openedFrom === 'timeline') {
      const page = getters.currentPage;
      const isTextPage = _.includes(page.groupBy, 'TEXT');
      const ignoredTextPages = ['textOverlay'];
      const isIgnored = _.includes(ignoredTextPages, page.id);
      const isThePage = isTextPage && !isIgnored;
      const hasTranscript = !_.isEmpty(state.workModel.metadata.transcript);
      const hasAudioOnTimeline = !_.isEmpty(
        rootState.timemachine.trackLayer.audio
      );
      return isThePage && (hasTranscript || hasAudioOnTimeline);
    } else {
      return false;
    }
  },

  /**
   * Realtime Preview checksum
   * According to current workModel + Story's Aspect Ratio
   * @return {String}
   */
  calRTPChecksum: (state, getters, rootState, rootGetters) => {
    return app.generateAssetRealTimeChecksum({
      visualTrack: _.cloneDeep(state.workModel),
      aspectRatio: state.story.aspectRatio.name,
      themeOverrides: rootGetters.themeOverrides,
    });
  },

  getVisualTrackSceneLayoutOnly: (state, getters) => {
    const id = 'layout_static_mask';
    const assetId = id + '_asset_server';
    const wallpaperAsset = {
      type: 'wallpapermetaasset',
      metadata: {
        assetUUID: assetId,
        providerAssetId: id,
        assetType: 'WALLPAPER',
      },
      id,
      displayDuration: 5,
      displayStartTime: 0,
      displayEndTime: 5,
      colorName: 'color1',
      wallpaperMetaData: {
        type: 'SOLID',
        wallpaperData: { colorValue: 'rgba(0,0,0,1)' },
      },
      agd: {
        customOverlays: [],
      },
    };

    const sceneLayoutCustomOverlay = getters.sceneLayoutCustomOverlay;
    wallpaperAsset.agd.customOverlays.push(
      state.workModel.agd.customOverlays?.find(
        (overlay) => overlay.id === sceneLayoutCustomOverlay?.id
      )
    );
    return wallpaperAsset;
  },
  /**
   * Scene Layout STP checksum
   * According to current workModel + Story's Aspect Ratio
   * @return {String}
   */
  calcSceneLayoutSTPChecksum: (state, getters, rootState, rootGetters) => {
    return app.generateAssetRealTimeChecksum({
      visualTrack: getters.getVisualTrackSceneLayoutOnly,
      aspectRatio: state.story.aspectRatio.name,
      themeOverrides: rootGetters.themeOverrides,
    });
  },

  /**
   * Does workModel need an RTP ?
   * @return {Boolean}
   */
  shouldPullRTP: (state) => {
    return app.realTimePreviewController.shouldPullPreview(
      _.cloneDeep(state.workModel)
    );
  },

  originalVideoSrc(state) {
    if (
      state.assetModel.isGIF() ||
      (state.assetModel.isSOCIALFRAGMENT() && state.currentPageId === 'crop')
    ) {
      return state.assetModel.getMetadata('url');
    } else if (_.isObject(state.assetModel.get('previewResultData'))) {
      return state.assetModel.get('previewResultData').cdnUrl;
    } else {
      return state.assetModel.getMetadata('urlCdn');
    }
  },

  originalImageSrc(state) {
    if (state.assetModel.isSOCIALIMAGE()) {
      return state.workModel.metadata.providerLowResAssetUrl;
    } else {
      return state.workModel.metadata.urlCdn;
    }
  },

  isGridEnabled: function (state) {
    return (
      (state.pageTmpState && !!state.pageTmpState.showNowThisGrid) ||
      !!state.pageTmpState.showGeneralGrid
    );
  },

  compareLayers:
    (state) =>
    ({ parentId, layer, index, presets }) => {
      const agdParent = state.workModel.agd[parentId];

      return (
        agdParent &&
        agdParent.filter((agdParentProp) => {
          // find all custom overlays in agd.customOverlays
          const preset = (presets || state.themeInfo.presets).find(
            (preset) => preset.id === agdParentProp.id
          );
          const presetLayer =
            preset && preset.layers && preset.layers[index || 0];
          // finds the first preset with the same id as the current inspected custom overlay and extract its layer
          return presetLayer === layer;
          // include in the result only presets with the given layer
        })
      );
    },

  isPageExistsInThemeInfo:
    (state) =>
    ({ childId, layer, index = 0 }) => {
      const preset = state.themeInfo.presets.find(
        (preset) => preset.id === childId
      );
      const presetLayer = preset && preset.layers && preset.layers[index];
      // finds the first preset with the same id as the current inspected custom overlay and extract its layer
      return presetLayer === layer;
      // include in the result only presets with the given layer
    },

  blockedThemeEffects: (state) => {
    return Object.keys(state.mappedThemeBlockedEffects).reduce(
      (previous, key) => {
        const isFieldBlocked = state.themeInfo[key] === false;
        if (isFieldBlocked) {
          return previous.concat(state.mappedThemeBlockedEffects[key]);
        } else {
          return previous;
        }
      },
      []
    );
  },

  selectedOverlayAsset: (state) => {
    if (state.tempTracks && state.tempTracks.length) {
      return state.tempTracks.find(
        (track) => track.guid === state.activeOverlayTrackGuid
      );
    }
    return null;
  },

  selectedLayout: (state, getters) => {
    if (!getters.selectedOverlayAsset) {
      return null;
    }
    return getters.selectedOverlayAsset.sceneLayout;
  },

  sceneLayoutCustomOverlay: (state) => {
    return state.workModel.agd.customOverlays?.find((overlay) => {
      return app.storyController.story
        ?.get('_layoutPresets')
        ?.includes(overlay.id);
    });
  },

  noInstantPreviewFieldsObject: (state, getters) => {
    return getters.currentPage
      ? (getters.currentPage.fields || []).reduce(
          (obj, field) => ({
            ...obj,
            [field.name]: field.noInstantPreview === true,
          }),
          {}
        )
      : {};
  },

  canBackToVideo(state) {
    return (
      /timeline|lightbox/.test(state.openedFrom) &&
      app.assetType.isFRAGMENT(state.workModel) &&
      !app.assetType.isFACEBOOK(state.workModel)
    );
  },

  assetTranscription(state, getters, rootState) {
    return rootState.story.transcriptions[state.workModel.metadata.assetUUID];
  },
};
